/** Extracts keys from object into an array */
/** For example {a: 1, b: {c: 3, d: 4}} => [1,3,4] */
/** Can be changed to lodash analog, etc. */
const extractObjectValues = (obj: any, res = []) => {
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === "string") {
      res.push(obj[key]);
    } else {
      extractObjectValues(obj[key], res);
    }
  });
  return res;
};

export default extractObjectValues;
